export const DEMO_RENEWAL_CHURN_RISK = 75;

export const DEMO_CALL_BASE = {
  id: "demo-call-renewal-risk",
  title: "Renewal review",
  customer_name: "SablePoint Logistics",
  company: "",
  occurred_at: "2026-08-05T15:00:00.000Z",
  created_at: "2026-08-05T15:00:00.000Z",
  duration: 600,
  filename: null,
  transcript: [
    "Rep: Hi Dana, thanks for making the time. With renewal five weeks out, I wanted to review adoption and make sure we are aligned on next steps.",
    "Customer: Sure. I should be upfront: the team likes the platform, but adoption has not been where we hoped.",
    "Rep: Is that mostly training, or are people not seeing enough value in the workflows?",
    "Customer: A bit of both. Operations uses it. Finance barely logs in. Sales stopped after the first month.",
    "Rep: Understood. We have added automated alerts, role-based dashboards, and the new forecasting view since rollout.",
    "Customer: I know. The product is not the issue. I just cannot show another year of spend against a few active users.",
    "Rep: We can surface more of the advanced features and build a re-engagement plan.",
    "Customer: Maybe, but we have also been speaking with AxisLoop. They include onboarding and quarterly adoption reviews in the price.",
    "Rep: Their feature set is quite a bit lighter. We have deeper integrations, configurable workflows, and better reporting.",
    "Customer: That may be true, but right now I am being asked why we are paying for capability nobody owns.",
    "Rep: When you say nobody owns it, what changed since launch?",
    "Customer: Priya led the rollout and left in May. Since then it has been mine by default, and I do not have the bandwidth or authority to drive adoption across departments.",
    "Rep: So the renewal problem is not primarily price or product. It is that there is no internal owner who can turn the platform into a business result. Is that fair?",
    "Customer: Yes. And the CFO wants a number. Time saved, errors reduced, something. People like it, but that alone won't get it renewed.",
    "Rep: What evidence would be credible to her?",
    "Customer: A baseline against the last quarter and a plan with someone accountable. Without that, AxisLoop looks safer because they do more of the rollout work.",
    "Rep: We can run a usage and ROI workshop, quantify the active workflows, and build a 90-day adoption plan with named owners. Could you bring the CFO and the operations lead?",
    "Customer: Operations, yes. The CFO will not join a vendor workshop unless I can send her something concrete first.",
    "Rep: Fair. I will send a one-page value snapshot by Friday using your usage data, then we can use Monday's workshop to validate the assumptions with Operations.",
    "Customer: That would help. But I do not want this framed as a renewal presentation. I need an honest view of whether we can get value in the next quarter.",
    "Rep: Agreed. If the numbers do not support a credible 90-day plan, we should say that. If they do, will you sponsor the recommendation internally?",
    "Customer: I can sponsor it, but I cannot promise the outcome. Procurement is already expecting an AxisLoop quote.",
    "Rep: Understood. Let us make the decision criteria explicit: measurable value, accountable ownership, and implementation support. I will send the snapshot Friday, workshop Monday at two, and we will decide whether there is a defensible renewal case.",
    "Customer: Monday at two works. Send me the snapshot early Friday so I can annotate it before I forward it.",
    "Rep: Will do. I will also include the current usage gaps so it does not read like marketing.",
    "Customer: Good. That is the right approach.",
  ].join("\n\n"),
  segments: [
    { start: 0, end: 20, speaker: "Rep", text: "Hi Dana, thanks for making the time. With renewal five weeks out, I wanted to review adoption and make sure we are aligned on next steps." },
    { start: 20, end: 45, speaker: "Customer", text: "Sure. I should be upfront: the team likes the platform, but adoption has not been where we hoped." },
    { start: 45, end: 62, speaker: "Rep", text: "Is that mostly training, or are people not seeing enough value in the workflows?" },
    { start: 62, end: 88, speaker: "Customer", text: "A bit of both. Operations uses it. Finance barely logs in. Sales stopped after the first month." },
    { start: 88, end: 112, speaker: "Rep", text: "Understood. We have added automated alerts, role-based dashboards, and the new forecasting view since rollout." },
    { start: 112, end: 140, speaker: "Customer", text: "I know. The product is not the issue. I just cannot show another year of spend against a few active users." },
    { start: 140, end: 159, speaker: "Rep", text: "We can surface more of the advanced features and build a re-engagement plan." },
    { start: 159, end: 188, speaker: "Customer", text: "Maybe, but we have also been speaking with AxisLoop. They include onboarding and quarterly adoption reviews in the price." },
    { start: 188, end: 213, speaker: "Rep", text: "Their feature set is quite a bit lighter. We have deeper integrations, configurable workflows, and better reporting." },
    { start: 213, end: 238, speaker: "Customer", text: "That may be true, but right now I am being asked why we are paying for capability nobody owns." },
    { start: 238, end: 263, speaker: "Rep", text: "When you say nobody owns it, what changed since launch?" },
    { start: 263, end: 290, speaker: "Customer", text: "Priya led the rollout and left in May. Since then it has been mine by default, and I do not have the bandwidth or authority to drive adoption across departments." },
    { start: 290, end: 314, speaker: "Rep", text: "So the renewal problem is not primarily price or product. It is that there is no internal owner who can turn the platform into a business result. Is that fair?" },
    { start: 314, end: 337, speaker: "Customer", text: "Yes. And the CFO wants a number. Time saved, errors reduced, something. People like it, but that alone won't get it renewed." },
    { start: 337, end: 365, speaker: "Rep", text: "What evidence would be credible to her?" },
    { start: 365, end: 393, speaker: "Customer", text: "A baseline against the last quarter and a plan with someone accountable. Without that, AxisLoop looks safer because they do more of the rollout work." },
    { start: 393, end: 418, speaker: "Rep", text: "We can run a usage and ROI workshop, quantify the active workflows, and build a 90-day adoption plan with named owners. Could you bring the CFO and the operations lead?" },
    { start: 418, end: 444, speaker: "Customer", text: "Operations, yes. The CFO will not join a vendor workshop unless I can send her something concrete first." },
    { start: 444, end: 466, speaker: "Rep", text: "Fair. I will send a one-page value snapshot by Friday using your usage data, then we can use Monday's workshop to validate the assumptions with Operations." },
    { start: 466, end: 493, speaker: "Customer", text: "That would help. But I do not want this framed as a renewal presentation. I need an honest view of whether we can get value in the next quarter." },
    { start: 493, end: 520, speaker: "Rep", text: "Agreed. If the numbers do not support a credible 90-day plan, we should say that. If they do, will you sponsor the recommendation internally?" },
    { start: 520, end: 543, speaker: "Customer", text: "I can sponsor it, but I cannot promise the outcome. Procurement is already expecting an AxisLoop quote." },
    { start: 543, end: 557, speaker: "Rep", text: "Understood. Let us make the decision criteria explicit: measurable value, accountable ownership, and implementation support. I will send the snapshot Friday, workshop Monday at two, and we will decide whether there is a defensible renewal case." },
    { start: 557, end: 577, speaker: "Customer", text: "Monday at two works. Send me the snapshot early Friday so I can annotate it before I forward it." },
    { start: 577, end: 591, speaker: "Rep", text: "Will do. I will also include the current usage gaps so it does not read like marketing." },
    { start: 591, end: 600, speaker: "Customer", text: "Good. That is the right approach." },
  ],
  notes: {},
  analysis: null,
  coaching: null,
  relationship_update: null,
};

const evidenceMoment = (timestamp, quote, description, confidence) => ({
  timestamp,
  description,
  quote,
  confidence,
});

const finding = (text, confidence, supportingMoments) => ({
  finding: { text, confidence },
  why: [],
  supporting_moments: supportingMoments,
});

export const DEMO_ANALYSIS = {
  buying_intent: 45,
  trust_level: 82,
  relationship_strength: 64,
  confidence_level: 71,
  risk_of_churn: DEMO_RENEWAL_CHURN_RISK,
  conversation_quality: 76,
  score_reasons: {
    buying_intent: "Dana remains open to a rescue plan, but renewal depends on measurable value, internal ownership, and executive approval.",
    trust_level: "Dana disclosed the ownership gap, CFO expectations, competitor activity, and procurement pressure with unusual candor.",
    relationship_strength: "The relationship is still constructive, but low adoption and the loss of the original champion have weakened the commercial foundation.",
    confidence_level: "The call ended with explicit decision criteria and dated actions, though the renewal outcome remains outside Dana's control.",
    risk_of_churn: "AxisLoop is already in procurement, adoption is weak, and no internal owner currently exists to defend the renewal.",
    conversation_quality: "The rep initially defended features too early, then recovered by diagnosing ownership and securing an evidence-led workshop.",
  },
  takeaway: {
    text: "The renewal is at genuine risk: adoption is low, the original champion has left, and a competitor is already in procurement. The call recovered only after the rep stopped defending features and secured a data-backed ROI review with explicit decision criteria.",
    confidence: 94,
  },
  commercial_status: {
    stage: { text: "Renewal rescue", confidence: 93 },
    decision_maker: {
      text: "Dana can sponsor the case; the CFO is the economic approver",
      confidence: 90,
    },
  },
  deep_dive: {
    stance: [
      finding(
        "The customer is not ready to renew, but remains open to an evidence-led recovery plan.",
        92,
        [
          evidenceMoment(
            "1:52",
            "I know. The product is not the issue. I just cannot show another year of spend against a few active users.",
            "Product satisfaction is not enough to justify the renewal internally.",
            94
          ),
          evidenceMoment(
            "8:40",
            "I can sponsor it, but I cannot promise the outcome. Procurement is already expecting an AxisLoop quote.",
            "Dana will support a credible case, but the outcome remains uncertain and competitive.",
            91
          ),
        ]
      ),
    ],
    tone: [
      finding(
        "Candid and skeptical, becoming more constructive once the ownership problem is named.",
        90,
        [
          evidenceMoment(
            "2:39",
            "Maybe, but we have also been speaking with AxisLoop. They include onboarding and quarterly adoption reviews in the price.",
            "Dana introduces the competitor directly instead of softening the concern.",
            89
          ),
          evidenceMoment(
            "7:46",
            "That would help. But I do not want this framed as a renewal presentation. I need an honest view of whether we can get value in the next quarter.",
            "Dana becomes constructive while setting a clear boundary against a sales-led presentation.",
            93
          ),
        ]
      ),
    ],
    blockers: [
      finding(
        "The original rollout owner left, and nobody now has the authority or bandwidth to drive adoption.",
        97,
        [
          evidenceMoment(
            "4:23",
            "Priya led the rollout and left in May. Since then it has been mine by default, and I do not have the bandwidth or authority to drive adoption across departments.",
            "The champion left and ownership fell to Dana without the mandate to lead adoption.",
            97
          ),
        ]
      ),
      finding(
        "The CFO requires quantified value before the renewal can be defended.",
        95,
        [
          evidenceMoment(
            "5:14",
            "Yes. And the CFO wants a number. Time saved, errors reduced, something. People like it, but that alone won't get it renewed.",
            "The economic approver requires measurable business impact rather than positive sentiment.",
            95
          ),
        ]
      ),
    ],
    objections: [
      finding(
        "Low adoption makes another year of spend difficult to justify.",
        96,
        [
          evidenceMoment(
            "1:52",
            "I know. The product is not the issue. I just cannot show another year of spend against a few active users.",
            "The objection is renewal economics relative to actual usage, not product capability.",
            96
          ),
        ]
      ),
      finding(
        "AxisLoop appears safer because implementation and adoption support are bundled.",
        92,
        [
          evidenceMoment(
            "6:05",
            "A baseline against the last quarter and a plan with someone accountable. Without that, AxisLoop looks safer because they do more of the rollout work.",
            "The competitor reduces perceived execution risk by taking more responsibility for adoption.",
            92
          ),
        ]
      ),
    ],
    risks: [
      finding(
        "Procurement is already expecting a competitor quote, leaving a narrow rescue window.",
        94,
        [
          evidenceMoment(
            "8:40",
            "I can sponsor it, but I cannot promise the outcome. Procurement is already expecting an AxisLoop quote.",
            "The renewal now competes with an active alternative already entering the buying process.",
            94
          ),
        ]
      ),
      finding(
        "Feature-led selling could reinforce the belief that the real business problem is being missed.",
        85,
        [
          evidenceMoment(
            "3:33",
            "That may be true, but right now I am being asked why we are paying for capability nobody owns.",
            "Dana rejects a feature comparison and redirects the conversation to ownership and value.",
            87
          ),
        ]
      ),
    ],
    opportunities: [
      finding(
        "A data-backed value snapshot and ROI workshop can rebuild a defensible renewal case.",
        91,
        [
          evidenceMoment(
            "7:24",
            "Fair. I will send a one-page value snapshot by Friday using your usage data, then we can use Monday's workshop to validate the assumptions with Operations.",
            "The rep converts the abstract ROI concern into a dated evidence-building process.",
            91
          ),
          evidenceMoment(
            "9:17",
            "Monday at two works. Send me the snapshot early Friday so I can annotate it before I forward it.",
            "Dana commits to the workshop and agrees to prepare the evidence for internal circulation.",
            93
          ),
        ]
      ),
    ],
  },
};

export const DEMO_COACHING = {
  empathy_score: 72,
  listening_score: 66,
  control_of_conversation: 58,
  skill_reasons: {
    empathy_score: "You acknowledged the ownership gap and agreed to an honest value review instead of pressuring Dana toward renewal.",
    listening_score: "You eventually identified the CFO's evidence standard and the missing owner, but only after responding to early concerns with features.",
    control_of_conversation: "You lost momentum during the feature defense, then regained control with a strong diagnostic question and a dated ROI process.",
  },
  what_worked: [
    {
      text: '“When you say nobody owns it, what changed since launch?” — You moved past the competitor comparison and uncovered the real operational blocker.',
      confidence: 96,
      timestamp: "03:58",
    },
    {
      text: '“What evidence would be credible to her?” — You translated a vague ROI concern into a concrete executive standard.',
      confidence: 94,
      timestamp: "05:37",
    },
    {
      text: '“Let us make the decision criteria explicit: measurable value, accountable ownership, and implementation support.” — You closed with a shared decision framework rather than a generic follow-up.',
      confidence: 93,
      timestamp: "09:03",
    },
  ],
  coaching_moves: [
    {
      title: "Diagnose the business risk before defending features",
      confidence: 95,
      situation: '“We have also been speaking with AxisLoop. They include onboarding and quarterly adoption reviews in the price.” - In response, you answered the competitor mention with a feature comparison before diagnosing what made the alternative feel safer.',
      timestamp: "02:39",
      better_move: "Do not answer the competitor mention with a feature comparison. Ask what feels safer about the alternative and which outcome the current platform has failed to produce.",
      example_phrase: "What specifically feels safer about AxisLoop: the product, the implementation support, or the confidence that someone will own adoption?",
      why_it_works: "It isolates the decision criterion before you position your solution and prevents a feature dump from confirming that you missed the real concern.",
    },
    {
      title: "Quantify the renewal gap earlier",
      confidence: 88,
      situation: "“I just cannot show another year of spend against a few active users.” - In response, you moved toward a re-engagement plan before quantifying the CFO's threshold for a defensible renewal.",
      timestamp: "01:52",
      better_move: "Pause before proposing re-engagement. Establish the adoption baseline, the cost of the current gap, and the CFO's threshold for a defensible renewal.",
      example_phrase: "What would the CFO need to see in numbers for another year to become defensible?",
      why_it_works: "It turns dissatisfaction into measurable decision criteria and gives the rest of the call a commercial target.",
    },
  ],
  missed_opportunities: [
    {
      text: '“We have added automated alerts, role-based dashboards, and the new forecasting view.” — You answered an adoption problem with product information before confirming why users disengaged.',
      confidence: 92,
      timestamp: "01:28",
    },
    {
      text: '“Their feature set is quite a bit lighter.” — You entered a feature comparison before learning that implementation ownership, not functionality, made the competitor feel safer.',
      confidence: 95,
      timestamp: "03:08",
    },
  ],
  questions_to_ask: [
    {
      text: '“The CFO will not join a vendor workshop unless I can send her something concrete first.” — Before you send the value snapshot: “Which two numbers would make the CFO willing to take the renewal case seriously?”',
      confidence: 95,
      timestamp: "06:58",
    },
    {
      text: '“A baseline against the last quarter and a plan with someone accountable.” — During Monday’s ROI workshop: “Which two workflows can produce measurable value within 90 days, and who owns each one?”',
      confidence: 93,
      timestamp: "06:05",
    },
    {
      text: '“Procurement is already expecting an AxisLoop quote.” — Before procurement compares the options: “Which implementation responsibilities are they using to judge AxisLoop as safer?”',
      confidence: 90,
      timestamp: "08:40",
    },
  ],
  negotiation_suggestions: [
    { text: "Do not compete feature-for-feature. Anchor the decision on measurable value, accountable ownership, and the level of implementation support required to achieve adoption.", confidence: 95 },
  ],
};

const firstPersonDefault = `Spoke with Dana ahead of the renewal. She was candid that the team likes the platform, but adoption is too low to justify another year: Operations uses it, Finance barely logs in, and Sales dropped off after the first month. AxisLoop is now in the process and currently feels safer because onboarding and adoption reviews are included.\n\nThe real blocker emerged when Dana explained that Priya, who owned the rollout, left in May. Dana inherited it without the bandwidth or authority to drive adoption. The CFO needs measurable value, not positive sentiment. I initially leaned too hard on features, then reframed around ownership and ROI.\n\nI will send a one-page value snapshot early Friday using current usage data, including the gaps, and we booked an ROI workshop for Monday at 2pm with Dana and Operations. Dana will sponsor a renewal recommendation only if we can show a credible 90-day value plan; procurement is already expecting an AxisLoop quote.`;

export const DEMO_NOTE_VARIANTS = {
  first_person: {
    default: firstPersonDefault,
    shorter: `Spoke with Dana. Renewal is at risk because adoption is low, Priya left, and nobody now owns the rollout. The CFO needs measurable ROI, while AxisLoop is already in procurement with bundled adoption support. I will send a one-page value snapshot Friday and run an ROI workshop Monday at 2pm with Dana and Operations. Dana will sponsor the case only if the data supports a credible 90-day plan.`,
    more_professional: `Dana confirmed that renewal cannot currently be justified because adoption is limited and the original rollout owner has left. AxisLoop is being evaluated as a lower-execution-risk alternative. I will deliver a usage-based value snapshot on Friday and facilitate an ROI workshop on Monday at 2pm with Dana and Operations. Any renewal recommendation will depend on a credible, measurable 90-day adoption plan.`,
    more_conversational: `Tough but useful call with Dana. The product is not the main issue: adoption is low, Priya left, and nobody owns the rollout now. The CFO wants numbers, and AxisLoop looks safer because they include more adoption support. I am sending a blunt one-page value snapshot Friday and meeting Dana plus Operations Monday at 2. If the data supports a real 90-day plan, Dana will sponsor it internally.`,
    more_detailed: `${firstPersonDefault}\n\nThe turning point was Dana's admission that the rollout no longer has an owner. On Monday I need to validate the usage baseline, identify a named owner, quantify a 90-day value target, and clarify procurement's timeline for the AxisLoop quote.`,
  },
  salesforce: {
    default: `Call outcome: Renewal at risk; evidence-led rescue path agreed.\n\nCustomer position: Product satisfaction remains positive, but low adoption and the loss of the rollout owner make another year difficult to justify.\n\nCompetition: AxisLoop is active in procurement and is perceived as safer because implementation support is bundled.\n\nDecision criteria: Measurable value, accountable ownership, and implementation support.\n\nCommitments: Rep sends a one-page value snapshot Friday. Dana and Operations attend ROI workshop Monday at 2pm.\n\nRisk: Dana can sponsor but cannot approve; CFO requires quantified value.`,
    shorter: `Renewal at risk. Low adoption, no internal owner, CFO needs ROI, AxisLoop active. Send value snapshot Friday; ROI workshop Monday 2pm. Dana sponsors only if a credible 90-day plan is proven.`,
    more_professional: `Renewal is at risk due to limited adoption, absent internal ownership, and unproven ROI. AxisLoop is under consideration. A value snapshot is due Friday, followed by a Monday ROI workshop to test whether a defensible 90-day adoption plan exists.`,
    more_conversational: `Hard renewal call. Dana likes the platform but cannot defend the spend with current adoption. AxisLoop is in play. We agreed on a Friday value snapshot and Monday ROI workshop to decide whether there is a real renewal case.`,
    more_detailed: `Outcome: Churn risk.\nAdoption: Operations active; Finance and Sales largely inactive.\nBlocker: Original champion left; no owner with authority or bandwidth.\nEconomic approval: CFO needs quantified value.\nCompetition: AxisLoop quote expected by procurement.\nNext steps: Value snapshot Friday; ROI workshop Monday at 2pm; define owner and 90-day target.`,
  },
  hubspot: {
    default: `Summary\nRenewal is at genuine risk. Dana likes the platform, but adoption is too low to justify another year and the original rollout owner has left. AxisLoop is being evaluated because its adoption support feels safer.\n\nNext steps\n• Send a usage-based value snapshot early Friday.\n• Include current adoption gaps, not only positive metrics.\n• Run ROI workshop Monday at 2pm with Dana and Operations.\n• Define measurable value and a named 90-day owner.\n\nDecision risk\nDana can sponsor the case, but the CFO requires numbers and procurement expects an AxisLoop quote.`,
    shorter: `Renewal at risk: low adoption, no owner, CFO needs ROI, AxisLoop active. Value snapshot Friday; ROI workshop Monday at 2pm.`,
    more_professional: `The renewal requires a quantified business case and a credible ownership model. A value snapshot will be delivered Friday, followed by an ROI workshop Monday with Dana and Operations.`,
    more_conversational: `Dana was very open: they like the platform, but nobody owns adoption and the CFO will not renew on sentiment. I am sending the numbers Friday and testing a 90-day recovery plan Monday.`,
    more_detailed: `Summary\nThe product remains positively regarded, but cross-functional adoption has failed and the original champion left.\n\nCommercial pressure\nAxisLoop is already in procurement and appears safer because rollout support is bundled.\n\nActions\n1. Send value snapshot Friday.\n2. Validate baseline Monday.\n3. Name an accountable owner.\n4. Define 90-day value targets.\n5. Confirm procurement timeline.`,
  },
  close: {
    default: `Renewal at risk. Dana likes the platform but cannot justify another year with low adoption. Priya left, leaving no internal owner. CFO needs measurable value. AxisLoop is already in procurement and feels safer due to bundled adoption support. Send honest value snapshot Friday; ROI workshop Monday 2pm with Dana + Operations. Dana sponsors only if a credible 90-day plan is proven.`,
    shorter: `Renewal at risk: low adoption, no owner, CFO needs ROI, AxisLoop active. Snapshot Friday; workshop Monday 2pm.`,
    more_professional: `Renewal is at risk due to adoption, ownership, and ROI gaps. A Friday value snapshot and Monday ROI workshop will determine whether a defensible 90-day plan exists.`,
    more_conversational: `Dana was blunt: the platform is fine, but nobody owns it and the numbers do not justify renewal yet. Friday snapshot, Monday workshop, then decide if there is a real case.`,
    more_detailed: `Churn risk. Operations uses the platform; Finance and Sales do not. Original champion left. CFO requires quantified value. AxisLoop is in procurement. Rep to send transparent value snapshot Friday. Dana and Operations join ROI workshop Monday at 2pm. Goal: prove a 90-day value plan with named ownership.`,
  },
  minimal: {
    default: `Renewal at risk.\nLow adoption. No internal owner. CFO needs ROI.\nAxisLoop active in procurement.\nValue snapshot Friday. ROI workshop Monday 2pm.\nDana sponsors only if a credible 90-day plan is proven.`,
    shorter: `Renewal at risk. Snapshot Friday; ROI workshop Monday. Prove value + ownership.`,
    more_professional: `Renewal risk: adoption, ownership, and ROI gaps. Evidence review Friday/Monday.`,
    more_conversational: `They like it, but cannot defend it yet. Numbers Friday, workshop Monday.`,
    more_detailed: `Status: Churn risk.\nObjections: Low adoption, unproven ROI.\nBlocker: No owner.\nCompetitor: AxisLoop.\nNext: Snapshot Friday; workshop Monday.`,
  },
  executive: {
    default: `Executive summary\nRenewal is at risk despite positive product sentiment. Adoption is limited, the original champion has left, and no accountable owner currently exists. The CFO requires quantified value, while AxisLoop is already progressing through procurement.\n\nRecovery path\nDeliver a transparent usage-based value snapshot Friday and use Monday's ROI workshop to establish a named owner, measurable 90-day outcomes, and a defensible recommendation.`,
    shorter: `Renewal at risk: weak adoption, no owner, ROI unproven, competitor active. Friday snapshot and Monday workshop will determine whether a defensible case exists.`,
    more_professional: `The renewal requires an evidence-based recovery plan that addresses adoption, accountability, and measurable value before executive approval is possible.`,
    more_conversational: `The product is liked, but the business case is not there yet. The next two deliverables must prove value and ownership, not sell features.`,
    more_detailed: `Executive summary\nCurrent adoption cannot support renewal economics. The departure of the rollout champion removed internal ownership. AxisLoop is viewed as lower risk because it bundles adoption support.\n\nRequired proof\n• Usage baseline and value snapshot\n• Named 90-day owner\n• Measurable outcome targets\n• Implementation support plan\n• Procurement timeline`,
  },
  detailed_history: {
    default: `5 Aug 2026 — Renewal review\nDana confirmed that product satisfaction remains positive, but low adoption and the loss of the rollout owner make renewal difficult to justify. The CFO requires measurable value, and AxisLoop is already active in procurement. I initially responded with features, then uncovered the ownership gap and reframed the call around ROI.\n\nI will send a transparent value snapshot Friday. Dana and Operations will join an ROI workshop Monday at 2pm to determine whether a credible 90-day renewal case exists.`,
    shorter: `5 Aug — Renewal at risk. No owner, low adoption, CFO needs ROI, AxisLoop active. Snapshot Friday; workshop Monday.`,
    more_professional: `5 Aug 2026 — The renewal moved into a formal rescue stage after adoption, ownership, and ROI gaps were confirmed. Evidence review is scheduled for Friday and Monday.`,
    more_conversational: `5 Aug — Dana was very direct: they like the platform, but nobody owns it and the CFO needs proof. We now have a Friday snapshot and Monday workshop to see if the account is saveable.`,
    more_detailed: `3 Jul — Quarterly check-in remained positive, with uneven cross-team adoption noted.\n22 Jul — Adoption review showed usage concentrated in Operations; a recovery review was planned.\n5 Aug — Dana revealed that Priya left and no internal owner replaced her. AxisLoop entered procurement, and the CFO required quantified value. A Friday value snapshot and Monday ROI workshop now form the conditional rescue path.`,
  },
};

export const DEMO_NOTE_SCORES = {
  overall: 91,
  human_writing: { score: 94 },
  template_language: { score: 90 },
  business_reasoning: { score: 94 },
  negotiation_insight: { score: 91 },
  emotional_accuracy: { score: 92 },
  customer_psychology: { score: 93 },
  future_usefulness: { score: 95 },
  writing_dna_similarity: { score: 88 },
  dna_profile: {
    calibrated: true,
    maturity_label: "Developing profile",
    confidence: 68,
  },
  dna_alignment: {
    applied: true,
    before_match: 81,
    after_match: 88,
  },
};

export const DEMO_RELATIONSHIP_DATA = {
  customer: {
    id: "demo-relationship-sablepoint",
    key: "demo-relationship-sablepoint",
    name: "SablePoint Logistics",
    company: "",
    call_count: 3,
    first_call_at: "2026-07-03T10:00:00.000Z",
    last_call_at: "2026-08-05T15:00:00.000Z",
  },
  milestones: [
    {
      call_id: "demo-call-renewal-risk",
      title: "Renewal review",
      date: "2026-08-05T15:00:00.000Z",
      customer_mood: "Candid, skeptical",
      main_objection: "Low adoption, no owner, ROI unproven",
      objection_status: "critical",
      turning_point: "Dana revealed that the original rollout owner left, shifting the issue from product fit to internal ownership and value.",
      next_step: "Send value snapshot Friday and run ROI workshop Monday at 2pm with Dana and Operations.",
      negotiation_stage: "Executive validation",
      confidence: 45,
      churn_risk: DEMO_RENEWAL_CHURN_RISK,
      outcome: "Churn risk",
      relationship_update: {
        previous_call_id: "demo-call-adoption-review",
        changes: {
          summary: [
            "Low adoption became a renewal justification problem",
            "The loss of the rollout owner was identified as the core blocker",
            "AxisLoop entered procurement",
            "A data-backed rescue process was agreed",
          ],
        },
      },
    },
    {
      call_id: "demo-call-adoption-review",
      title: "Adoption review",
      date: "2026-07-22T09:30:00.000Z",
      customer_mood: "Concerned but engaged",
      main_objection: "Usage concentrated in Operations",
      objection_status: "persistent",
      turning_point: "Dana agreed to review inactive workflows and collect department feedback before renewal planning.",
      next_step: "Review usage data and prepare cross-team adoption recommendations.",
      negotiation_stage: "Adoption recovery",
      confidence: 63,
      churn_risk: 48,
      outcome: "In progress",
      relationship_update: {
        previous_call_id: "demo-call-quarterly-check-in",
        changes: {
          summary: ["Adoption concern became explicit", "Renewal still appeared recoverable"],
        },
      },
    },
    {
      call_id: "demo-call-quarterly-check-in",
      title: "Quarterly check-in",
      date: "2026-07-03T10:00:00.000Z",
      customer_mood: "Positive",
      main_objection: "Cross-team adoption uneven",
      objection_status: "improving",
      turning_point: "Dana described strong Operations usage and expected broader adoption with additional enablement.",
      next_step: "Share enablement material and schedule an adoption review.",
      negotiation_stage: "Renewal healthy",
      confidence: 74,
      churn_risk: 30,
      outcome: "Recorded",
      relationship_update: {
        previous_call_id: null,
        changes: {
          summary: [
            "New relationship established",
            "Operations showed early value while cross-team adoption remained uneven",
            "Renewal still appeared healthy with additional enablement",
          ],
        },
      },
    },
  ],
  objection_evolution: [
    { text: "Feature coverage concern resolved", status: "resolved" },
    { text: "Cross-team adoption remains weak", status: "persistent" },
    { text: "Internal ownership gap became critical", status: "critical" },
    { text: "ROI proof and competitor pressure are now active", status: "critical" },
  ],
  relationship_memory: {
    available: true,
    needs_rebuild: false,
    last_processed_call_id: "demo-call-renewal-risk",
    current_state: {
      as_of_call_id: "demo-call-renewal-risk",
      bookmark: {
        text: "Renewal at risk; evidence-led rescue in progress",
        tone: "critical",
      },
      facts: {
        customer_position:
          "Dana likes the platform but cannot defend another year without measurable value, accountable ownership, and stronger implementation support. AxisLoop is already active in procurement.",
        stakeholders: [
          { name: "Dana", role: "Day-to-day contact and potential internal sponsor", source_call_id: "demo-call-renewal-risk" },
          { name: "CFO", role: "Economic approver requiring quantified value", source_call_id: "demo-call-renewal-risk" },
          { name: "Operations lead", role: "Workshop participant and possible 90-day owner", source_call_id: "demo-call-renewal-risk" },
          { name: "Procurement", role: "Managing the AxisLoop comparison", source_call_id: "demo-call-renewal-risk" },
        ],
        commitments: [
          {
            owner: "rep",
            status: "open",
            text: "Send a transparent one-page value snapshot using current usage data, including the gaps.",
            deadline: "Friday morning",
            source_call_id: "demo-call-renewal-risk",
          },
          {
            owner: "customer",
            status: "open",
            text: "Annotate the value snapshot and bring the Operations lead to the ROI workshop.",
            deadline: "Monday at 2pm",
            source_call_id: "demo-call-renewal-risk",
          },
          {
            owner: "rep",
            status: "open",
            text: "Run the ROI workshop and build a 90-day plan with measurable outcomes and named ownership.",
            deadline: "Monday at 2pm",
            source_call_id: "demo-call-renewal-risk",
          },
        ],
        commercial_objections: [
          {
            text: "Current adoption does not justify another year of spend.",
            status: "open",
            source_call_id: "demo-call-renewal-risk",
          },
          {
            text: "AxisLoop appears safer because onboarding and adoption support are bundled.",
            status: "open",
            source_call_id: "demo-call-renewal-risk",
          },
        ],
        operational_blockers: [
          {
            text: "The original rollout owner left and no replacement has the authority or bandwidth to drive adoption.",
            status: "open",
            source_call_id: "demo-call-renewal-risk",
          },
          {
            text: "The CFO requires quantified value before joining or approving the renewal process.",
            status: "open",
            source_call_id: "demo-call-renewal-risk",
          },
        ],
        process_preferences: [
          {
            text: "Dana wants an honest, data-led value review rather than a renewal presentation.",
            status: "active",
            source_call_id: "demo-call-renewal-risk",
          },
          {
            text: "The value snapshot should be concise, transparent, and sent early enough for Dana to annotate before forwarding.",
            status: "active",
            source_call_id: "demo-call-renewal-risk",
          },
        ],
      },
      inferences: {
        buying_intent: { score: 45 },
        churn_risk: { score: DEMO_RENEWAL_CHURN_RISK },
        trust: { score: 82 },
        relationship_strength: { score: 64 },
        attitude: {
          text: "Open, but proof required",
          source_call_id: "demo-call-renewal-risk",
        },
        emotional_tone: {
          text: "Candid, skeptical, increasingly constructive",
          source_call_id: "demo-call-renewal-risk",
        },
        risks: [
          {
            text: "Procurement is already expecting an AxisLoop quote, leaving limited time to rebuild the business case.",
            source_call_id: "demo-call-renewal-risk",
          },
          {
            text: "Without a named internal owner, any temporary adoption lift is unlikely to survive the next quarter.",
            source_call_id: "demo-call-renewal-risk",
          },
        ],
        opportunities: [
          {
            text: "Dana will sponsor a recommendation if the usage data supports a credible 90-day value and ownership plan.",
            source_call_id: "demo-call-renewal-risk",
          },
        ],
      },
    },
    next_call_brief: {
      risks: [
        {
          text: "Procurement is already expecting an AxisLoop quote, so the Monday workshop must create a decision-ready business case rather than another discovery cycle.",
          source_call_id: "demo-call-renewal-risk",
        },
        {
          text: "A polished sales presentation would damage trust if it avoids the current usage gaps.",
          source_call_id: "demo-call-renewal-risk",
        },
      ],
      opportunities: [
        {
          text: "Dana is willing to sponsor the case if the workshop produces quantified value, named ownership, and a credible 90-day plan.",
          source_call_id: "demo-call-renewal-risk",
        },
      ],
    },
    prepare_next_call: {
      schema_version: 2,
      generated_at: "2026-08-05T16:00:00.000Z",
      relationship_state_version: 4,
      source_call_count: 3,
      source_call_ids: ["demo-call-quarterly-check-in", "demo-call-adoption-review", "demo-call-renewal-risk"],
      latest_call_id: "demo-call-renewal-risk",
      latest_call_at: "2026-08-05T15:00:00.000Z",
      output_language_code: "en",
      last_call_outcome: "At risk, conditional path agreed",
      relationship_state: "Executive validation",
      next_recommended_action: "Use the Monday workshop to quantify value, name an accountable owner, and decide whether a defensible renewal case exists.",
      script_ready: true,
      priority: "high",
      conversation_strategy: "Lead with the transparent usage baseline, not product features. Validate the business impact with Operations, identify a credible 90-day owner, and make the AxisLoop decision criteria explicit.",
      objective: {
        text: "Produce a decision-ready 90-day value plan that Dana can sponsor with the CFO.",
        confidence: "high",
        basis: "Dana agreed to sponsor a recommendation only if measurable value and accountable ownership can be demonstrated.",
      },
      likely_objections: [
        {
          text: "The current usage baseline is too weak to support a credible renewal case.",
          response_direction: "Acknowledge the gap. Separate existing realized value from the 90-day recoverable value, then test whether the plan is operationally realistic.",
          confidence: "high",
          basis: "Dana explicitly said another year cannot be justified against a few active users.",
        },
        {
          text: "AxisLoop still feels safer because more implementation support is included.",
          response_direction: "Do not argue feature depth. Compare ownership, implementation workload, measurable outcomes, and accountability across both paths.",
          confidence: "high",
          basis: "Dana described the competitor as safer because it takes more responsibility for rollout and adoption.",
        },
        {
          text: "No internal person can own the 90-day adoption plan.",
          response_direction: "Test whether the Operations lead has enough mandate and what executive sponsorship is required. Do not leave ownership as a generic team responsibility.",
          confidence: "high",
          basis: "The original champion left and Dana lacks the authority and bandwidth to lead cross-functional adoption.",
        },
      ],
      suggested_call_flow: [
        {
          title: "Start with the real baseline",
          purpose: "Review active workflows, inactive departments, and current measurable value without framing the gaps defensively.",
        },
        {
          title: "Quantify recoverable value",
          purpose: "Estimate time saved, errors reduced, and the 90-day outcomes Operations believes are achievable.",
        },
        {
          title: "Name accountable ownership",
          purpose: "Confirm who has the mandate and capacity to own the adoption plan across departments.",
        },
        {
          title: "Compare decision risk",
          purpose: "Make the implementation support and ownership differences between the current platform and AxisLoop explicit.",
        },
        {
          title: "Decide whether a renewal case exists",
          purpose: "Leave with a sponsor-ready recommendation, required changes, or an honest conclusion that renewal is not defensible.",
        },
      ],
      questions_to_ask: [
        {
          text: "Which workflows created measurable value last quarter, and where can we verify that in the data?",
          why: "It anchors the workshop in evidence rather than feature potential.",
        },
        {
          text: "What 90-day outcome would be meaningful enough for the CFO to defend the spend?",
          why: "It turns renewal approval into a concrete business threshold.",
        },
        {
          text: "Who can own this plan with enough authority to drive Finance and Sales adoption?",
          why: "It prevents the ownership gap from remaining an unnamed team responsibility.",
        },
        {
          text: "What does AxisLoop remove from your execution risk that you do not believe we remove today?",
          why: "It isolates the competitor's real advantage without entering a feature comparison.",
        },
      ],
      next_call_script: {
        opening: {
          text: "Thanks for joining. Dana asked us to keep this honest, so I want to start with the current usage gaps, then test whether there is a credible 90-day value and ownership plan. If the evidence does not support that, we should say so.",
          why_it_fits: "It respects Dana's explicit preference and lowers resistance by making the workshop diagnostic rather than promotional.",
        },
        mid_call_pivots: [
          {
            trigger: "If the usage baseline is weaker than expected",
            text: "Let us separate what is already proven from what is realistically recoverable in 90 days. Which one or two workflows have both measurable impact and an owner?",
          },
          {
            trigger: "If no owner is available",
            text: "Then ownership is the decision, not a follow-up task. Who would need to sponsor this role, and is that realistic before renewal?",
          },
          {
            trigger: "If AxisLoop is raised",
            text: "Rather than compare feature lists, what implementation risk does AxisLoop remove for you, and what would we need to match operationally?",
          },
        ],
        closing: {
          text: "Based on the evidence, do we have a defensible renewal case, who owns the 90-day plan, and what exactly will Dana take to the CFO?",
          why_it_fits: "It forces the workshop to produce a sponsor-ready decision rather than another open-ended adoption discussion.",
        },
        keep_in_mind: "Dana rewards candor and will disengage if the conversation becomes a feature pitch. Treat the usage gaps as shared evidence, not objections to overcome.",
      },
      personalization: {
        rep_voice_summary: "You are strongest when you summarize the commercial problem plainly and close on concrete actions. The script preserves that directness while preventing an early return to feature-led selling.",
        customer_style_summary: "Dana is candid, analytical, and willing to collaborate when the discussion is evidence-led. She resists promotional framing and distinguishes sponsorship from decision authority.",
        adaptation_notes: [
          "Open with the usage gaps before any positive narrative.",
          "Use 'rep' consistently and avoid feature comparisons unless tied to a decision criterion.",
          "Ask for measurable thresholds, not general signs of success.",
          "Treat ownership as a commercial condition, not an implementation detail.",
          "Close with a sponsor-ready recommendation and procurement timeline.",
        ],
        rep_voice_confidence: 88,
        customer_style_confidence: 91,
        rep_profile_maturity: "established",
        customer_profile_maturity: "developing",
        rep_sample_call_count: 12,
        customer_sample_call_count: 3,
      },
    },
  },
};
